import { Heart, ArrowRight, Sparkles, Building2, Megaphone } from "lucide-react";

const ways = [
    {
        icon: Heart,
        title: "Back our mission",
        desc: "A direct contribution helps fund our first units, pilots, and the data that makes the case for the next wave.",
    },
    {
        icon: Building2,
        title: "Open a door",
        desc: "Introduce us to a county, a foundation, or a system leader who needs this on the ground.",
    },
    {
        icon: Megaphone,
        title: "Amplify the work",
        desc: "Share Kairos with your network — every visibility win moves the access gap closer to closed.",
    },
];

export const Support = () => {
    return (
        <section
            id="support"
            data-testid="support-section"
            className="relative bg-[#0A1428] text-white py-28 md:py-36 overflow-hidden"
        >
            <div className="absolute inset-0 dot-grid-light opacity-30 pointer-events-none" />
            <div className="absolute -top-40 -left-32 w-[520px] h-[520px] opacity-[0.07] pointer-events-none float-slower">
                <svg viewBox="0 0 200 200">
                    <polygon points="20,160 100,40 180,160" fill="#F0493E" />
                </svg>
            </div>
            <div className="absolute -bottom-40 -right-32 w-[600px] h-[600px] opacity-[0.05] pointer-events-none float-slow">
                <svg viewBox="0 0 200 200">
                    <polygon
                        points="20,160 130,60 180,160"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="1.5"
                    />
                </svg>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-x-8 gap-y-16 items-start">
                    <div className="col-span-12 lg:col-span-5 reveal">
                        <div className="inline-flex items-center gap-3 mb-6">
                            <Sparkles
                                size={16}
                                strokeWidth={1.5}
                                className="text-[#F0493E]"
                            />
                            <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                                Support Our Work
                            </span>
                        </div>

                        <h2 className="font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-balance">
                            We&apos;re building this
                            <br />
                            with the public, for
                            <br />
                            <span className="text-[#F0493E]">the public.</span>
                        </h2>

                        <p className="mt-8 text-lg text-slate-300 leading-relaxed font-medium max-w-md">
                            Kairos ORD is a mission-driven LLC, not a 501(c)(3) — contributions
                            are not tax-deductible. But every dollar, intro,
                            and share moves a unit closer to a wall, a
                            hallway, or a cell block where someone&apos;s life
                            will depend on it.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row gap-4">
                            <a
                                href="https://gofund.me/1e2e141a6"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="support-cta-primary"
                                className="btn-primary inline-flex items-center justify-center gap-3 px-8 py-4 text-sm font-bold tracking-wide uppercase rounded-sm"
                            >
                                Support our work
                                <ArrowRight size={18} strokeWidth={2} />
                            </a>
                            <a
                                href="mailto:kairosord@gmail.com?subject=Supporting%20Kairos%20ORD"
                                data-testid="support-cta-email"
                                className="inline-flex items-center justify-center gap-3 px-8 py-4 text-sm font-bold tracking-wide uppercase rounded-sm border border-white/30 text-white hover:bg-white hover:text-[#0A1428] transition-colors"
                            >
                                Email us directly
                            </a>
                        </div>

                        <div className="mt-8 inline-flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.28em] text-slate-500">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#F0493E]" />
                            Powered by GoFundMe · Secure giving
                        </div>
                    </div>

                    <div className="col-span-12 lg:col-span-7 reveal lg:pl-8">
                        <div className="grid grid-cols-1 gap-px bg-white/10 border border-white/10">
                            {ways.map((w, i) => (
                                <div
                                    key={w.title}
                                    data-testid={`support-way-${i}`}
                                    className="bg-[#0A1428] p-8 md:p-10 group hover:bg-[#0d1a36] transition-colors"
                                >
                                    <div className="flex items-start gap-6">
                                        <div className="shrink-0 h-12 w-12 grid place-items-center border border-white/20 group-hover:border-[#F0493E] transition-colors">
                                            <w.icon
                                                size={22}
                                                strokeWidth={1.5}
                                                className="text-[#F0493E]"
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="font-display font-bold text-xl md:text-2xl text-white tracking-tight">
                                                {w.title}
                                            </h3>
                                            <p className="mt-2 text-sm md:text-[15px] text-slate-400 leading-relaxed font-medium">
                                                {w.desc}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
